module.exports = __webpack_public_path__ + "static/media/NOSSOSSERVICOS.0efefdd8.png";